import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { ThemeModule } from '../theme/theme.module';
import { SharedModule } from '../shared/shared.module';
import { LoginModule } from '../login/login.module';
import { CompaniesRoutingModule } from './companies-routing.module';
import { SignupComponent } from './signup/signup.component';
import { AmplifyAngularModule } from 'aws-amplify-angular';
import { PricingTableComponent } from '../pricing-table/pricing-table.component';

@NgModule({
  imports: [
    ThemeModule
    ,SharedModule
    ,LoginModule
    ,AmplifyAngularModule
    ,CompaniesRoutingModule
  ],
  declarations: [SignupComponent, PricingTableComponent]
})
export class CompaniesModule { }




// WEBPACK FOOTER //
// ./src/app/companies/companies.module.ts